var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M3.595 7.837L8 13.384l4.405-5.547H9.778a.88.88 0 0 1-.89-.871V2.612A.88.88 0 0 0 8 1.742a.88.88 0 0 0-.889.87v4.354a.88.88 0 0 1-.889.87H3.595zm8.81-1.742c.982 0 1.778.78 1.778 1.742 0 .387-.132.763-.375 1.069l-4.405 5.548a1.803 1.803 0 0 1-2.806 0L2.192 8.906a1.718 1.718 0 0 1 .312-2.444 1.802 1.802 0 0 1 1.091-.367h1.738V2.612C5.333 1.17 6.527 0 8 0c1.473 0 2.667 1.17 2.667 2.612v3.483h1.738zm1.817 8.708c0-.481.398-.871.89-.871.49 0 .888.39.888.87 0 1.924-1.592 3.484-3.556 3.484H3.556C1.592 18.286 0 16.726 0 14.803c0-.481.398-.871.889-.871.49 0 .889.39.889.87 0 .963.796 1.742 1.778 1.742h8.888c.982 0 1.778-.78 1.778-1.741z", id: "svg2117611571a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(2 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg2117611571b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg2117611571a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg2117611571a" }),
      React.createElement(
        "g",
        { mask: "url(#svg2117611571b)", fill: "currentColor" },
        React.createElement("path", { d: "M-2-1h20v20H-2z" })
      )
    )
  );
});